import React from 'react'
import './Footer.scss'

interface IProps {
  'data-attribute'?: any,
}

const Footer = ({ 'data-attribute': dataAttribute }: IProps) => {
  return (
    <div className='footer-wrapper' data-attribute={dataAttribute}>
        <div className='text-center'>&copy; 2021-2023 Brightview. All Rights Reserved.</div>
    </div>
  )
}

export default Footer
